export default __webpack_public_path__ + "static/latenight_background-d40ed2980c42416175511707d1b2a0fc.png";